/* eslint-disable import/no-extraneous-dependencies */
import { configureStore } from '@reduxjs/toolkit';
import { devToolsEnhancer } from 'redux-devtools-extension';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import EventDispatcher from '@pharmaplan/common/helpers/EventDispatcher';
import rootReducer from '../reducers/rootReducer';

const rootPersistConfig = {
  key: 'root',
  storage,
  whitelist: ['user'],
};

const store = configureStore({
  reducer: persistReducer(rootPersistConfig, rootReducer),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: false,
  enhancers: [devToolsEnhancer({})],
});

const persistor = persistStore(store);

EventDispatcher.set(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export { store, persistor };
